import { useAppSelector } from "@/stores";

export default function useAuthentication() {
    return useAppSelector(state => state.auth)
}